import { authHeaders } from './apiFetch';

export const removeFromWishlist= async (productID, callback) => {
    try {
        const response = await fetch('/api/user/wishlist', {
            method: "DELETE",
            headers: authHeaders({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({ productID })
        });
        const data = await response.json();
        if (data.success) {
            callback();
        } else {
            // error notify user
        }
    } catch (error) {
        // error notify user
    }
};

export const clearWishlist = async (callback) => {
    try {
      const response = await fetch('/api/user/wishlist/clear', {
        method: "DELETE",
        headers: authHeaders({})
      });
      const data = await response.json();
      if (data.success) {
          callback();
      } else {
        // error notify user
      }
    } catch (error) {
      // error notify user
    }
};